import { defineStore } from "pinia";

import type { PersonStaff } from "../../cbi-generator/generated/dto/PersonStaff";
import { usePersonService } from "../../cbi-generator/frontend/composables/usePersonFrontendService";

/**
 * Store for managing Person objects
 */
export const usePersonStore = defineStore("persons", () => {
  const service = usePersonService();
  const personDetails = shallowRef<ReadonlyMap<number, PersonStaff>>(new Map());

  /**
   * Load a bound generated staff DTO without eagerly fetching history relations.
   * @public
   */
  const searchPersonById = async (
    personId: number,
    forceFetch: boolean = false,
  ): Promise<PersonStaff> => {
    const cached = personDetails.value.get(personId);
    if (cached && !forceFetch) return cached;
    const person = await service.getPersonStaff(personId, {
      referrals: false,
      damageWaivers: false,
      phones: false,
      personRatings: false,
      memberships: false,
      addresses: false,
      cards: false,
      personTypes: false,
      apClassesInstructing: false,
      jpClassesInstructing: false,
      apClassSignups: false,
      jpClassSignups: false,
      apClassTypeOverrides: false,
      jpClassTypeOverrides: false,
      relationsA: false,
      relationsB: false,
      checkIns: false,
      activeCardNum: true,
      activeMembershipTypeName: true,
      activeMembershipExpiration: true,
    });
    personDetails.value = new Map(personDetails.value).set(personId, person);
    return person;
  };

  const clearPersons = () => {
    personDetails.value = new Map();
  };
  const updatePersonDetails = (person: PersonStaff) => {
    personDetails.value = new Map(personDetails.value).set(
      person.personId,
      person,
    );
  };

  return {
    searchPersonById,
    updatePersonDetails,
    clearPersons,
  };
});
